import { API_URLS } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import MagazineCard from '@stories/Components/Cards/MagazineCard/MagazineCard';
import Filters from '@stories/Components/Listings/Filters/Filters';
import Pagination from '@stories/Components/Listings/Pagination/Pagination';
import LoadingIndicator from '@stories/Components/Misc/LoadingIndicator/LoadingIndicator';
import qs from 'query-string';
import * as React from 'react';
import { ArrayParam, NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import S from './MagazinesListing.styles';
const MagazinesListing = (props) => {
    const pagingRef = React.useRef(null);
    const [params, setParams] = useQueryParams(Object.assign({
        location: withDefault(StringParam, props.initialData.location ?? ''),
        pageIndex: withDefault(NumberParam, 1),
        pageSize: withDefault(NumberParam, 9),
        sortBy: withDefault(StringParam, props.sortOptions ? props.sortOptions.value : ''),
    }, ...props.filterOptions.map((f) => ({
        [f.name]: withDefault(ArrayParam, []),
    }))));
    const result = useApi({
        initialData: props.initialData,
        url: `${API_URLS.GET_MAGAZINES}?${qs.stringify(params)}`,
    });
    const filterOptions = props.filterOptions.map((f) => ({
        ...f,
        value: params[f.name],
        onChange: (value) => {
            const values = params[f.name];
            if (value === '') {
                setParams({ [f.name]: [value] }, 'pushIn');
            }
            else if (values.includes(value)) {
                setParams({ [f.name]: values.filter((v) => v !== value) }, 'pushIn');
            }
            else {
                setParams({ [f.name]: [...values, value] }, 'pushIn');
            }
            setParams({ pageIndex: 1 }, 'pushIn');
            scrollToTop();
        },
        onClear: () => {
            setParams({ [f.name]: [], pageIndex: 1 }, 'pushIn');
            scrollToTop();
        },
    }));
    const onResetClick = () => {
        const resetParams = props.filterOptions.map((f) => ({ [f.name]: [] }));
        setParams({ ...resetParams, pageIndex: 1 }, 'push');
        scrollToTop();
    };
    const sortOptions = props.sortOptions
        ? {
            ...props.sortOptions,
            value: params.sortBy,
            onChange: (value) => {
                setParams({ sortBy: value, pageIndex: 1 }, 'pushIn');
                scrollToTop();
            },
        }
        : undefined;
    return (React.createElement(S.Container, { id: props.anchorId, layout: "fullWidth" },
        React.createElement(S.FiltersWrapper, null,
            React.createElement(S.Inner, null,
                React.createElement(Filters, { filterOptions: filterOptions, sortOptions: sortOptions, clearAll: () => onResetClick(), selectedTitle: props.translations?.['global.selectedFilters'] ?? 'Selected Filters', viewButtonLabel: props.translations?.['listings.viewMagazines'] ?? 'View Magazines' }))),
        React.createElement(S.Inner, null, result.data && (React.createElement(React.Fragment, null,
            result.data.items.length > 0 && (React.createElement(S.PagingText, { ref: pagingRef, "data-layout": "top" },
                React.createElement("span", null,
                    (params.pageIndex - 1) * params.pageSize + 1,
                    " -",
                    ' ',
                    params.pageIndex * params.pageSize,
                    " of ",
                    result.data.totalCount),
                ' ',
                "magazines")),
            renderResults(),
            result.data.items.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Pagination, { pageIndex: params.pageIndex, pageSize: params.pageSize, totalCount: result.data.totalCount, onPageChange: (value) => {
                        setParams({ pageIndex: value }, 'pushIn');
                        scrollToTop();
                    } }),
                React.createElement(S.PagingText, { "data-layout": "bottom" },
                    React.createElement("span", null,
                        (params.pageIndex - 1) * params.pageSize + 1,
                        " -",
                        ' ',
                        params.pageIndex * params.pageSize,
                        " of ",
                        result.data.totalCount),
                    ' ',
                    "magazines")))))),
        result.status === 'loading' && React.createElement(LoadingIndicator, { label: "Loading\u2026", layout: "fixed" })));
    function renderResults() {
        return (React.createElement(S.ResultsContainer, null, !result.data?.items?.length ? (React.createElement(S.NoResultsText, null, "No results found.")) : (React.createElement(React.Fragment, null, result.data.items.map((item) => (React.createElement(MagazineCard, { key: item.id, ...item, translations: props.translations })))))));
    }
    function scrollToTop() {
        /** timeout required to ensure scrolling occurs on prev/next buttons */
        setTimeout(() => pagingRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
        }), 50);
    }
};
export default withQueryParams(MagazinesListing);
